import {defineSlotRecipe} from '@chakra-ui/react3'

export const MODULE_CONTAINER_LAYOUT_MAP = {
    'full-width': {
        modulePadding: 'media',
        layerStyle: null
    },
    inline: {
        modulePadding: 'default',
        layerStyle: 'container.page'
    }
}

export const mediaSlotRecipe = defineSlotRecipe({
    className: 'media-module',
    slots: ['container', 'mediaWrapper', 'darkenLayer'],
    base: {
        mediaWrapper: {
            position: 'relative',
            overflow: 'hidden',
            width: '100%'
        },
        darkenLayer: {
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            zIndex: 1
        }
    },
    variants: {
        layout: {
            'full-width': {
                container: {
                    paddingBlock: 'spacing-0'
                },
                mediaWrapper: {
                    borderRadius: 'none'
                }
            },
            inline: {
                container: {
                    paddingBlock: {
                        base: 'container-padding-mobile',
                        s: 'container-padding-desktop'
                    }
                },
                mediaWrapper: {
                    borderRadius: 'm'
                }
            }
        },
        darken: {
            '0%': {
                darkenLayer: {
                    display: 'none'
                }
            },
            '40%': {
                darkenLayer: {
                    bg: 'gradient.bottom.darken-40'
                }
            },
            '80%': {
                darkenLayer: {
                    bg: 'gradient.bottom.darken-80'
                }
            },
            '100%': {
                darkenLayer: {
                    bg: 'gradient.bottom.darken-100'
                }
            }
        }
    },
    defaultVariants: {
        layout: 'full-width',
        darken: '0%'
    }
})

export default mediaSlotRecipe
